/**
 * Buso mega menu — desktop hover
 */
class BusoMegaHoverMenu {
  constructor() {
    this.closeDelay = 150;
    this.closeTimer = null;
    this.mq = window.matchMedia('(hover: hover) and (min-width: 990px)');
    this.zone =
      document.querySelector('.section-header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('.buso-header');

    if (!this.zone) return;
    this.currentOpen = null;
    this.bind();
    this.mq.addEventListener('change', () => {
      if (!this.mq.matches) this.closeAll();
    });
  }

  isDesktop() {
    return this.mq.matches;
  }

  bind() {
    this.zone.querySelectorAll('.buso-mega-nav__item').forEach((item) => {
      const details = item.querySelector('details.buso-mega');
      if (!details) {
        item.addEventListener('mouseenter', () => {
          if (!this.isDesktop()) return;
          clearTimeout(this.closeTimer);
          this.closeAll();
        });
        return;
      }

      const panel = details.querySelector('.buso-mega__panel');
      const enter = () => this.onEnter(details);

      item.addEventListener('mouseenter', enter);
      panel?.addEventListener('mouseenter', enter);

      details.querySelector('summary')?.addEventListener('click', (event) => {
        if (!this.isDesktop()) return;
        // Keep hover-open behavior (don't toggle details).
        event.preventDefault();

        // If the group has an optional link, allow clicking the title to navigate.
        const link = event.target.closest('a.buso-mega-nav__group-link');
        if (!link) return;
        const href = link.getAttribute('href');
        if (!href || href === '#') return;
        window.location.assign(link.href);
      });
    });

    this.zone.addEventListener('mouseleave', (event) => {
      if (!this.isDesktop()) return;
      const next = event.relatedTarget;
      if (next && this.zone.contains(next)) return;
      this.scheduleClose();
    });

    this.zone.addEventListener('mouseenter', () => {
      clearTimeout(this.closeTimer);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeAll();
    });

    window.addEventListener(
      'scroll',
      () => {
        if (!this.isDesktop()) return;
        this.closeAll();
        this.syncStickyPreventHide();
      },
      { passive: true }
    );
  }

  syncStickyPreventHide() {
    const sticky = document.querySelector('sticky-header');
    if (sticky) {
      sticky.preventHide = !!document.querySelector('.buso-mega details[open]');
    }
  }

  onEnter(details) {
    if (!this.isDesktop()) return;
    clearTimeout(this.closeTimer);
    this.zone
      .querySelectorAll('details.buso-mega[open]')
      .forEach((openDetails) => {
        if (openDetails !== details) this.close(openDetails);
      });
    this.open(details);
  }

  scheduleClose() {
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => this.closeAll(), this.closeDelay);
  }

  open(details) {
    if (!details) return;
    this.zone
      .querySelectorAll('details.buso-mega[open]')
      .forEach((openDetails) => {
        if (openDetails !== details) this.close(openDetails);
      });
    details.setAttribute('open', '');
    details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    this.currentOpen = details;
    this.updateHeaderBottom();
    this.syncStickyPreventHide();
  }

  close(details) {
    if (!details) return;
    details.removeAttribute('open');
    details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    if (this.currentOpen === details) this.currentOpen = null;
    this.syncStickyPreventHide();
  }

  closeAll() {
    this.zone.querySelectorAll('details.buso-mega[open]').forEach((el) => this.close(el));
    this.syncStickyPreventHide();
  }

  updateHeaderBottom() {
    const header =
      document.querySelector('.header-wrapper') || document.querySelector('.section-header');
    if (!header) return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(header.getBoundingClientRect().bottom)}px`
    );
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new BusoMegaHoverMenu();
});
